import { useDelete } from '@refinedev/core';

export const useDeleteTemplateMutation = () => {
  const { mutateAsync: deleteResource, isLoading, isError } = useDelete();
  const deleteTemplate = async (companyId: string, templateId: string) => {
    await deleteResource({
      resource: `admin/companies/${companyId}/templates`,
      id: templateId,
    });
  };

  return {
    deleteTemplate,
    isLoading,
    isError,
  };
};
